import { useNavigate } from 'react-router-dom';
import './styles.css';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { useEffect } from 'react';
import { Card } from 'react-bootstrap';
import {session} from "../../../../services/storage.service";

const DocumentoAssinado = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const cleanSession = () => {
            setTimeout(() => {
                session.clear();
                return navigate('/asos-assinados');
            }, 2500);
        }
        cleanSession();
    }, []);

    return(
        <>
            <Card className="aso-doc-card">
                <Card.Body className='aso-doc-card-body'>
                    <AssignmentTurnedInIcon sx={{ fill: '#127902', width: '150px', height: '150px', marginBottom: '20px' }} />
                    <Card.Title className='aso-doc-cardTitle text-center'>O ASO referente a esta consulta já está assinado!</Card.Title>
                    <Card.Text className='aso-doc-cardSubTitle text-center'>Aguarde o redirecionamento automático...</Card.Text>
                </Card.Body>
            </Card>
        </>
    );
}

export default DocumentoAssinado;